/**
 * --------------------------------
 * REGISTER GSAP PLUGINS
 * --------------------------------
 */

gsap.registerPlugin(ScrollTrigger)

